module.exports = __webpack_public_path__ + "img/pharmacy.5a17a755.svg";